import LabelIcon from "./LabelIcon";

import "./index.css";

interface SubtitleProps {
  text: string;
  type: TemplateType;
  style?: React.CSSProperties;
  iconPath?: string;
  styleContainer?: React.CSSProperties;
}

const Label = (props: SubtitleProps) => {
  const { text, style = {}, type, iconPath = null, styleContainer = {} } = props;

  const formatText = (text: string) => ({ __html: text.replace(/\n/g, "<br>") });

  return (
    <>
      {iconPath !== null && (
        <div className="base-label-container" style={styleContainer}>
          <LabelIcon iconPath={iconPath} />
          <div className={`base-label base-label-${type}`} style={style} dangerouslySetInnerHTML={formatText(text)} />
        </div>
      )}
      {iconPath === null && <div className={`base-label base-label-${type}`} style={style} dangerouslySetInnerHTML={formatText(text)} />}
    </>
  );
};

export default Label;
